import * as types from './mutation-types'
import cookie from '../../static/js/cookie'
// 类似于事件 每个mutation都有字符类型的事件类型和回调函数
// 全局引入vue
import Vue from 'vue'
import Axios from 'axios'
Vue.prototype.$http = Axios

export default {
  [types.SET_INFO] (state) {
    state.userInfo = {
      username: cookie.getCookie('username'),
      token: cookie.getCookie('token'),
      name: cookie.getCookie('name'),
      system_num: cookie.getCookie('system_num'),
    }
    state.currentCity = JSON.parse(localStorage.getItem('currentCity'))|| ''
    state.testlanguage = sessionStorage.getItem('testlanguage') || ''
    // console.log(state.userInfo.headimg)
  },
  [types.NEED_LOGIN] (state) {
    state.needLogin = true
  },
  [types.NO_LOGIN] (state) {
    state.needLogin = false
  }
}



// WEBPACK FOOTER //
// ./src/vuex/mutations.js